export const environment = {
    production: true,
    featurevisorDatafileUrl:
        "/featurevisor/development/featurevisor-tag-all.json",
    integrations: {
        airplaneManager:
            "https://corp.airplanemanager2.com/app/externalcredentials?vendor=PFM&token=:token:",
    },
    sentryEnvironmentName: "development",
};
